import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

import { includesConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { usePracticeAreaList } from 'hooks/usePracticeAreaList';

const assignToItemTemplate = (option) => {
  if (option?.status === 'ARCHIVED') {
    return `${option?.practice_area_name} (Archived)`;
  }
  return option?.practice_area_name;
};

const PracticeAreaFilter = ({
  index,
  loadCaseMatter,
  loadVenue,
  getEventTypes,
  isCaseMatterSelected,
  isVenueSelected,
  isEventTypeSelected,
  loadLeadStages,
  isLeadStageTypeSelected,
  loadGlobalList,
  isTagTypeSelected,
}) => {
  const { practiceAreaList, isPracticeAreaLoading } = usePracticeAreaList();
  const {
    formState: { errors },
    control,
    getValues,
    setValue,
  } = useFormContext();

  useEffect(() => {
    const currentValue = getValues(`filters.${index}.value`);
    const selectedValues = currentValue?.['case_description.case_practice_area'] || [];

    if (selectedValues.length > 0 && practiceAreaList?.length > 0) {
      const validOptionIds = new Set(practiceAreaList.map((option) => option.practice_area_id));
      const validValues = selectedValues.filter((value) => validOptionIds.has(value));

      if (validValues.length !== selectedValues.length) {
        setValue(`filters.${index}.value`, { 'case_description.case_practice_area': validValues }, { shouldValidate: true });
      }
    }
  }, [practiceAreaList, index, getValues, setValue]);

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              options={includesConditionOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Select Condition"
              className="w-100"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <MultiSelect
              options={practiceAreaList}
              value={(field.value?.['case_description.case_practice_area'] || []).filter((selected) =>
                practiceAreaList?.some((option) => option.practice_area_id === selected)
              )}
              name={field.name}
              onChange={(e) => {
                field.onChange({ 'case_description.case_practice_area': e.value });
                if (isCaseMatterSelected) {
                  loadCaseMatter(e.value);
                }
                if (isVenueSelected) {
                  loadVenue(e.value);
                }
                if (isEventTypeSelected) {
                  getEventTypes(e.value);
                }
                if (isLeadStageTypeSelected) {
                  if (e.value?.length > 0) {
                    loadLeadStages(e.value?.map((id) => `practice_area#${id}`));
                  } else {
                    loadLeadStages(practiceAreaList?.map((item) => `practice_area#${item.practice_area_id}`));
                  }
                }
                if (isTagTypeSelected) {
                  loadGlobalList(e.value);
                }
              }}
              filter
              className="input-shadow w-100"
              display="chip"
              placeholder="Select Value"
              optionValue="practice_area_id"
              optionLabel="practice_area_name"
              itemTemplate={assignToItemTemplate}
              dropdownIcon={isPracticeAreaLoading ? 'pi pi-spin pi-spinner' : undefined}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default PracticeAreaFilter;
